import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useRef } from "react";
import { OurPartnersCarousel } from "./OurPartnersCarousel";
import { ChevronLeft, ChevronRight, IconButton, InsidePageWrapper, Typography } from "@parkschannel/ui";
import { useOurPartners } from "../hooks";
import { OurPartner } from "../types";
export const OurPartnersSection = (param)=>{
    let { itemBackground  } = param;
    const carouselRef = useRef(null);
    const { useOurPartnersQuery  } = useOurPartners();
    const { data: ourPartners  } = useOurPartnersQuery();
    const partners = useMemo(()=>{
        var ref;
        return ((ourPartners === null || ourPartners === void 0 ? void 0 : (ref = ourPartners.data) === null || ref === void 0 ? void 0 : ref.partners) || []).map((member)=>OurPartner.fromOurPartnersResponse(member));
    }, [
        ourPartners
    ]);
    const slideNext = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slideNext(null);
    };
    const slidePrev = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slidePrev(null);
    };
    if (partners.length === 0) return null;
    return /*#__PURE__*/ _jsxs("section", {
        className: "w-full overflow-x-hidden pt-6 pb-[72px] lg:pt-[56px] lg:pb-[100px]",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "px-4 md:px-[30px] lg:px-[40px]",
                children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center mb-6 lg:mb-[60px] ",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                component: "h2",
                                variant: "h3",
                                className: "text-neutral-900",
                                children: "Our partners"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "hidden lg:flex lg:gap-1",
                                children: [
                                    /*#__PURE__*/ _jsx(IconButton, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ _jsx(ChevronLeft, {}),
                                        onClick: slidePrev
                                    }),
                                    /*#__PURE__*/ _jsx(IconButton, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ _jsx(ChevronRight, {}),
                                        onClick: slideNext
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(OurPartnersCarousel, {
                carouselRef: carouselRef,
                itemBackground: itemBackground,
                data: partners
            })
        ]
    });
};
